import LaravelRepository from "@/providers/api/repositories/LaravelRepository"
export default class Auth extends LaravelRepository {
  route = "auth"
  namespace = "auth"

  state = {
    user: {}
  }

  actions = {
    login: async ({ commit }, params) => {
      let response = await this.request({ namespace: "login" }).post("/auth/login", params)
      if (response.isError) return response
      commit("SET_USER", response.data)
      return true
    },
    logout: async ({ commit }) => {
      let response = await this.request({ namespace: "logout" }).get("/auth/logout")
      if (response.isError) return response
      commit("CLEAR_USER")
    },
    check: async ({ commit }) => {
      let response = await this.request({ namespace: "check" }).get("/auth/user")
      if (response.isError) return response
      commit("SET_USER", response.data)
      // commit("SET_EXPIRATION", promise.data)
    },
    forgotPassword: async ({ commit }, params) => {
      return this.request({ namespace: "forgot-password" }).post("/forgot-password/create", params)
    },
    findPasswordToken: async (ctx, token) => {
      const response = await this.request({ namespace: "forgot-password/find" }).get("/forgot-password/find/" + token)
      return response
    },
    resetPassword: async (ctx, params) => {
      const response = await this.request({ namespace: "forgot-password/reset" }).post("/forgot-password/reset", params)
      return response
    }
    // update: async (params) => {
    //   //               .post
    //   return await this.request("/user/update", params)
    //   // dispatch("user")
    // },
    // changePassword: async (params) => {
    //   //               .post
    //   return await this.request("/user/change-password", params)
    // },
    //
  }
  getters = {
    isAuthenticated: (state) => {
      return Object.keys(state.user).length !== 0
    }
  }
  mutations = {
    SET_USER: (state, payload) => {
      state.user = payload
    },
    CLEAR_USER: (state) => {
      state.user = {}
    }
  }
}
